import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

export class SeasonalityAdjustmentNameColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n,
    inlineEditConfig: {
      onEditName,
    } = {},
    scope,
  }) {
    super({
      name: 'SeasonalityAdjustmentName',
      title: _TL_('Name'),
      i18n,
      property: 'Name',
      sortable: 'Name',
      group: 'freezing',
    });
    this.onEditName = onEditName;
    this.scope = scope;
  }

  onPrompt(...args) {
    return this.onEditName(...args);
  }
}
